import React, { useContext, useState,useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { signOut } from 'aws-amplify/auth';
import {
  FaHome, FaRobot, FaChartBar, FaUsers,
  FaCog, FaLifeRing, FiLogOut, FaFlask
} from 'react-icons/fa';
import { MdTimeline } from 'react-icons/md';
import RootContext from '@/RootContext';
import './Sidebar.css';
import logosvg from '@/assets/images/OpenPath_Icon_512x512.png';
import SidebarContext from '@/SidebarContext';
import { FaSignOutAlt } from 'react-icons/fa';

const Sidebar = () => {
  
  const rootContext = useContext(RootContext);
  const auth = rootContext.get('auth');
  const { isOpen, setIsOpen } = useContext(SidebarContext);

  const allowedHosts = new Set([
    'publisher.com',
    'dev.openpath.ai'
  ]);

  const handleSignOut = async () => {
    try {
      await signOut();
      rootContext.set('auth', undefined);
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  useEffect(() => {
  rootContext.set('sidebarOpen', isOpen);
}, [isOpen]);


  return (
   
<aside
  className={`sidebar border-end shadow-sm ${isOpen ? 'expanded' : 'collapsed'}`}
  onMouseEnter={() => setIsOpen(true)}
  onMouseLeave={() => setIsOpen(false)}
>
 
  <div className="mt-4 ">

        <div className="mb-4 text-center">
          <img
            src={logosvg}
            alt="Logo"
            width={32}
          />
        </div>




    <ul className="nav flex-column gap-3" style={{ listStyleType: 'none', fontWeight: '400' }}>
      <SidebarItem to="/app/dashboard" icon={<FaHome />} label="Home" isOpen={isOpen} />
      <SidebarItem to="/app/pipeline" icon={<MdTimeline />} label="Enrollment Pipeline" isOpen={isOpen} />
      <SidebarItem to="/app/ai" icon={<FaRobot />} label="AI Assistant" isOpen={isOpen} />
      <SidebarItem to="/app/chatbot-studio" icon={<FaFlask />} label="Chatbot Config Studio" isOpen={isOpen} />
      <SidebarItem to="/app/customers" icon={<FaUsers />} label="Customer Engagement" isOpen={isOpen} />
      {/*<SidebarItem to="/app/analytics" icon={<FaChartBar />} label="Analytics" isOpen={isOpen} />*/}
    </ul>
  </div>

 <div
  className={`p-4 border-top d-flex flex-column ${
    isOpen ? 'align-items-center text-center' : 'align-items-center text-center'
  }`} style={{ marginTop: '5rem' }}
>
   <ul className="nav flex-column gap-3 mb-3">
  <SidebarItem  to="/user-account" icon={<FaCog />} label="Settings" isOpen={isOpen} />
  {/* <SidebarItem to="/app/support" icon={<FaLifeRing />} label="Support" isOpen={isOpen} /> */}
</ul>

    {/* <div className="d-flex align-items-start mb-2">
      <img
        src="https://i.pravatar.cc/40"
        alt="User"
        className="rounded-circle me-2"
        width="40"
        height="40"
      />
      {isOpen && (
        <div >
          <div className="fw-semibold mb-0" style={{ fontSize: '0.9rem' }}>
            {auth?.given_name || 'User'}
          </div>
        </div>
      )}
    </div> */}

        <button
          onClick={handleSignOut}
          className={`btn d-flex align-items-center gap-2 px-2 py-2 ${!isOpen ? 'justify-content-center' : ''}`}
        >
          <FaSignOutAlt
            color="#2E2868"
            style={{
              width: isOpen ? 18 : 18,
              height: isOpen ? 18 : 18,
              flexShrink: 0
            }}
          />
          {isOpen && <span>Sign out</span>}
        </button>





  </div>
</aside>

  );
};

const SidebarItem = ({ to, icon, label, isOpen }) => (
  <li className="nav-item">
    <NavLink to={to} className="nav-link d-flex align-items-center text-muted"
>
      <span className="icon-box" aria-hidden="true">{icon}</span>
      {isOpen && <span className="label">{label}</span>}
    </NavLink>
  </li>
);

export default Sidebar;




